import { createSlice } from '@reduxjs/toolkit'

const initialModulesState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: null,
    moduleForEdit: undefined,
    lastError: null,
    internalError: null,
    stayOpen: true,
    batchResult: []
}
export const callTypes = {
    list: 'list',
    action: 'action'
}

export const ModulesReducers = createSlice({
    name: 'modules',
    initialState: initialModulesState,
    reducers: {
        setOpen: (state) => {
            state.stayOpen = true
        },
        catchError: (state, action) => {
            state.lastError = `${action.type}: ${action.payload.error}`
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false
            } else {
                state.actionsLoading = false
            }
            state.stayOpen = true
        },
        catchBadRequest: (state, action) => {
            state.lastError = `${action.payload.error}`
            state.listLoading = false
            state.actionsLoading = false
            state.stayOpen = true
        },
        catchInternalError: (state, action) => {
            state.internalError = `${action.payload.error}`
            state.listLoading = false
            state.actionsLoading = false
            state.stayOpen = true
        },
        startCall: (state, action) => {
            state.lastError = null
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true
            } else {
                state.actionsLoading = true
            }
            state.stayOpen = true
        },
        // getModuleById
        moduleFetched: (state, action) => {
            state.actionsLoading = false
            state.moduleForEdit = action.payload.moduleForEdit
            state.lastError = null
            state.internalError = null
        },
        // findModules
        modulesFetched: (state, action) => {
            const { totalCount, entities } = action.payload
            state.listLoading = false
            state.lastError = null
            state.entities = entities
            state.totalCount = totalCount
            state.stayOpen = true
        },
        // createModule
        moduleCreated: (state, action) => {
            state.actionsLoading = false
            state.lastError = null
            state.entities.push(action.payload.module)
            state.stayOpen = false
        },
        // updateModule
        moduleUpdated: (state, action) => {
            state.lastError = null
            state.actionsLoading = false
            state.stayOpen = false
            state.entities = state.entities.map(entity => {
                if (entity.id === action.payload.module.module_id) {
                    return action.payload.module
                }
                return entity
            })
        },
        // deleteModule
        moduleDeleted: (state, action) => {
            state.lastError = null
            state.actionsLoading = false
            state.entities = state.entities.filter(el => el.id !== action.payload.module_id)
        },
        // deleteModules
        modulesDeleted: (state, action) => {
            state.lastError = null
            state.actionsLoading = false
            state.stayOpen = false
            state.entities = state.entities.filter(
                el => !action.payload.ids.includes(el.id)
            )
        },
        // modulesUpdateState
        modulesStatusUpdated: (state) => {
            state.actionsLoading = true
            state.lastError = null
            state.stayOpen = true
        },
        // modulesDeleteState
        modulesDeletedState: (state) => {
            state.actionsLoading = true
            state.lastError = null
            state.stayOpen = true
        },
        // setBatchResultStatus
        setBatchResult: (state, action) => {
            state.batchResult.push(action.payload.data)
        },
        // batchActionsFinished
        batchActionsFinished: (state) => {
            state.actionsLoading = false
            state.lastError = null
            state.stayOpen = true
        },
        // setInitBatch
        reInitBatch: (state) => {
            state.actionsLoading = false
            state.internalError = null
            state.lastError = null
            state.stayOpen = true
            state.batchResult = []
        }
    }
})
